import React from 'react';
import {connect} from "react-redux";
import {Form, FormGroup, Modal} from "react-bootstrap";
import { Formik, Field } from 'formik';
import {SUPPORT_MODAL_HIDE, validateChangeDeliveryPhone} from "../actions";

class InternalModal extends React.Component {


  render() {
    const {modal, hide, validate} = this.props;

    if (!modal.address) {
      return null;
    }

    return <Modal
      show={modal && modal.modalType === 'delivery_phone'}
      animation={false}
      backdrop={true}
      onHide={() => hide()}
      keyboard={true}
      className="ChangeDeliveryNameModal"
    >
      <Modal.Body>
        <h4>{modal.title}</h4>
        <Formik
          initialValues={{
            phone: modal.address.phone ? modal.address.phone : '',
            address: modal.address,
          }}
          onSubmit={(values, actions) => {

            let newAddress = {
              ...values.address,
              phone: values.phone,
            };

            validate(newAddress);
          }}
          render={(props: FormikProps<Values>) => {

            return <div style={{paddingLeft:"20px", paddingRight:"20px"}}>
              <form onSubmit={props.handleSubmit} className="form-horizontal">
                <FormGroup>
                  <Form.Label>Numéro de téléphone</Form.Label>
                  <Field
                    name="phone"
                    className="form-control"
                    required="required"
                  />
                </FormGroup>
              <FormGroup style={{textAlign:"center"}}>
                <button type="submit" className="btn btn-primary">Enregistrer</button>
              </FormGroup>
              </form>
            </div>;
          }}
        />
      </Modal.Body>
    </Modal>;

  }
}


export const ChangeDeliveryPhoneModal = connect(
  (state) => ({
    "modal" : state.support.modal,
  }),
  (dispatch) => {
    return {
      "hide": () => {
        dispatch({"type": SUPPORT_MODAL_HIDE});
      },
      "validate": (values) => {
        dispatch({'type': SUPPORT_MODAL_HIDE});
        dispatch(validateChangeDeliveryPhone(
          values
        ));
      }
    };
  }
)(InternalModal);

